import { common } from '../main/common-sidecar'
import { scene } from '../main/scene-sidecar'
import { dialogs } from '../uiParts/dialogs-sidecar'
import { checkboxes } from '../uiParts/checkboxes-sidecar'
import { layers } from '../main/layers-sidecar'
import { settings } from '../engine/settings-sidecar'
import { ICheckbox } from '../uiParts/checkboxes'
import { l } from '../lib/imports'
import { clickEater } from '../uiParts/clickEater-sidecar'

interface IData {
  isOpen: boolean
  dialog: dialogs.IDialog

  controls: ICheckbox[]
}
let _data: IData | null = null

export const getData = () => {
  if (!_data) {
    let controls: ICheckbox[] = []

    _data = {
      isOpen: false,
      dialog: dialogs.create(15, 15, 200, 50, 'Preferences / Options!', () => {
        setOpen(false)
      }),
      controls,
    }

    let ctx = scene.getContext()
    let x = 200
    let y = 100
    let cb = checkboxes.create(
      layers.getLayers().ui,
      x,
      y,
      'Skip Start Screen',
      () => {
        return settings.get().skipStart
      },
      (newVal) => {
        settings.update({ skipStart: newVal })
      },
    )
    controls.push(cb)
    y += 50
    cb = checkboxes.create(
      layers.getLayers().ui,
      x,
      y,
      'Play Sounds',
      () => {
        return !settings.get().muteSound
      },
      (newVal) => {
        settings.update({ muteSound: !newVal })
      },
    )
    controls.push(cb)
    y += 50
    cb = checkboxes.create(
      layers.getLayers().ui,
      x,
      y,
      'Play Music',
      () => {
        return !settings.get().muteMusic
      },
      (newVal) => {
        settings.update({ muteMusic: !newVal })
      },
    )
    controls.push(cb)
    setOpen(false)
  }
  return _data
}

export const toggle = () => {
  setOpen(!getData().isOpen)
}

export const setOpen = (isOpen: boolean) => {
  clickEater.update('uiPreferences', isOpen)

  let data = getData()

  data.isOpen = isOpen
  dialogs.setVisible(data.dialog, isOpen)

  l.forEach(data.controls, (c) => {
    checkboxes.setVisible(c, isOpen)
  })
}

export const update = () => {
  // TODO: if active
  let s = common.getPhaserScene()
  let ctx = scene.getContext()
}
